import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import ReactSVG from 'react-svg'
import React, { useState } from 'react'
import useTranslation from 'next-translate/useTranslation'
import { getDeliveryInfo } from '../../selectors'

const Delivery = ({ deliveryInfo }) => {
	const [expanded, setExpanded] = useState(false)
	const { t } = useTranslation('common')

	if (!deliveryInfo) return null

	return (
		<section className='vehicle-part-delivery'>
			<div className='vehicle-part-delivery-header'>
				<ReactSVG src='/icons/free-delivery.svg' beforeInjection={(svg) => {
					svg.setAttribute('width', '53px')
					svg.setAttribute('height', '40px')
				}} />

				<div className='vehicle-part-delivery-header-text vehicle-part-delivery-header-text-mobile'>
					<p className='vehicle-part-delivery-header-text-title'>{t('BESPLATNA DOSTAVA')}</p>
					<p className='vehicle-part-delivery-header-text-description'>{t('za većinu gradova Crne Gore')}</p>
				</div>

				<div className='vehicle-part-delivery-header-text vehicle-part-delivery-header-text-tablet-desktop'>
					<p className='vehicle-part-delivery-header-text-title'>{t('BESPLATNA DOSTAVA')}</p>
					<p className='vehicle-part-delivery-header-text-description'>{t('odnosi se na isporuke u gradskim jezgrima za većinu gradova Crne Gore')}</p>
				</div>

				<div className='vehicle-part-delivery-header-text vehicle-part-delivery-header-text-desktop-xl'>
					<p className='vehicle-part-delivery-header-text-title'>{t('BESPLATNA DOSTAVA')}</p>
					<p className='vehicle-part-delivery-header-text-description'>{t('Besplatna isporuka odnosi se na isporuke u gradskim jezgrima za većinu gradova Crne Gore')}</p>
				</div>

				<div className='vehicle-part-delivery-header-expand vehicle-part-delivery-header-expand-mobile'>
					<button onClick={() => setExpanded(!expanded)}>
						<ReactSVG src='/icons/otvori1.svg' beforeInjection={(svg) => {
							svg.setAttribute('width', '16px')
							svg.setAttribute('height', '10px')
							svg.setAttribute('style', 'transform: ' + (expanded ? 'rotate(180deg)' : 'rotate(0deg)') + ';')
						}} wrapper='span' />
					</button>
				</div>

				<div className='vehicle-part-delivery-header-expand vehicle-part-delivery-header-expand-desktop-tablet'>
					<button onClick={() => setExpanded(!expanded)}>
						<p>{!expanded ? t('saznajVise') : t('Zatvori')}</p>

						<ReactSVG src='/icons/otvori1.svg' wrapper='span' beforeInjection={(svg) => {
							svg.setAttribute('width', '16px')
							svg.setAttribute('height', '10px')
							svg.setAttribute('style', 'transform: ' + (expanded ? 'rotate(180deg)' : 'rotate(0deg)') + ';')
						}} />
					</button>
				</div>
			</div>

			<div className={`vehicle-part-delivery-content ${expanded ? 'vehicle-part-delivery-content--expanded' : ''}`}>
				<div className='vehicle-part-delivery-content-cities'>
					{deliveryInfo.cities.map(city => (
						<table key={city.name} className='vehicle-part-delivery-content-region'>
							<thead>
								<tr className='vehicle-part-delivery-content-region-header--mobile'><th colSpan='8'>{city.name}</th></tr>
								<tr className='vehicle-part-delivery-content-region-header--desktop-tablet'>
									<th>{city.name}</th>
									<th>{t('PON')}</th>
									<th>{t('UTO')}</th>
									<th>{t('SRI')}</th>
									<th>{t('ČET')}</th>
									<th>{t('PET')}</th>
									<th>{t('SUB')}</th>
									<th>{t('NED')}</th>
								</tr>
							</thead>

							<tbody>
								{city.cities.length > 1 ? (
									<>
										<tr className='vehicle-part-delivery-content-region-row--mobile'>
											<td>{t('Grad')}</td>
											<td>{t('PON')}</td>
											<td>{t('UTO')}</td>
											<td>{t('SRI')}</td>
											<td>{t('ČET')}</td>
											<td>{t('PET')}</td>
											<td>{t('SUB')}</td>
											<td>{t('NED')}</td>
										</tr>
										{city.cities.map(city => {
											return (
												<tr key={city.name} className='vehicle-part-delivery-content-region-row'>
													<td className='vehicle-part-delivery-content-region-city-name'>{city.name}</td>
													<td className='vehicle-part-delivery-content-region-city-short-name'>{city.shortName}</td>
													<td className='vehicle-part-delivery-content-region-row-icon'>
														<ReactSVG src='/icons/094.dostava.svg' beforeInjection={(svg) => {
															svg.querySelectorAll('.fil0').forEach(path => {
																path.setAttribute('style', 'fill: ' + (city.deliveryWeekdays.monday ? '#000' : '#eee') + ';')
															})
														}} />
													</td>
													<td className='vehicle-part-delivery-content-region-row-icon'>
														<ReactSVG src='/icons/094.dostava.svg' beforeInjection={(svg) => {
															svg.querySelectorAll('.fil0').forEach(path => {
																path.setAttribute('style', 'fill: ' + (city.deliveryWeekdays.tuesday ? '#000' : '#eee') + ';')
															})
														}} />
													</td>
													<td className='vehicle-part-delivery-content-region-row-icon'>
														<ReactSVG src='/icons/094.dostava.svg' beforeInjection={(svg) => {
															svg.querySelectorAll('.fil0').forEach(path => {
																path.setAttribute('style', 'fill: ' + (city.deliveryWeekdays.wednesday ? '#000' : '#eee') + ';')
															})
														}} />
													</td>
													<td className='vehicle-part-delivery-content-region-row-icon'>
														<ReactSVG src='/icons/094.dostava.svg' beforeInjection={(svg) => {
															svg.querySelectorAll('.fil0').forEach(path => {
																path.setAttribute('style', 'fill: ' + (city.deliveryWeekdays.thursday ? '#000' : '#eee') + ';')
															})
														}} />
													</td>
													<td className='vehicle-part-delivery-content-region-row-icon'>
														<ReactSVG src='/icons/094.dostava.svg' beforeInjection={(svg) => {
															svg.querySelectorAll('.fil0').forEach(path => {
																path.setAttribute('style', 'fill: ' + (city.deliveryWeekdays.friday ? '#000' : '#eee') + ';')
															})
														}} />
													</td>
													<td className='vehicle-part-delivery-content-region-row-icon'>
														<ReactSVG src='/icons/094.dostava.svg' beforeInjection={(svg) => {
															svg.querySelectorAll('.fil0').forEach(path => {
																path.setAttribute('style', 'fill: ' + (city.deliveryWeekdays.saturday ? '#000' : '#eee') + ';')
															})
														}} />
													</td>
													<td className='vehicle-part-delivery-content-region-row-icon'>
														<ReactSVG src='/icons/094.dostava.svg' beforeInjection={(svg) => {
															svg.querySelectorAll('.fil0').forEach(path => {
																path.setAttribute('style', 'fill: ' + (city.deliveryWeekdays.sunday ? '#000' : '#eee') + ';')
															})
														}} />
													</td>
												</tr>
											)
										})}
									</>
								) : (
									<>
										<tr className='vehicle-part-delivery-content-region-row-last--mobile'>
											<td colSpan='8'>
												Kolašin, Mojkovac, Berane, Bijelo Polje, Žabljak, Šavnik<br />{t('Jednom u 15 dana')}.
											</td>
										</tr>

										<tr className='vehicle-part-delivery-content-region-row-last--desktop-tablet'>
											<td>
												{t('Jednom u 15 dana')}
											</td>

											<td>
												<ReactSVG src='/icons/094.dostava.svg' beforeInjection={(svg) => {
													svg.setAttribute('width', '28px')
													svg.setAttribute('height', '15px')

													svg.querySelectorAll('.fil0').forEach(path => {
														path.setAttribute('style', 'fill: #eee;')
													})
												}} />
											</td>

											<td>
												<ReactSVG src='/icons/094.dostava.svg' beforeInjection={(svg) => {
													svg.setAttribute('width', '28px')
													svg.setAttribute('height', '15px')

													svg.querySelectorAll('.fil0').forEach(path => {
														path.setAttribute('style', 'fill: #eee;')
													})
												}} />
											</td>

											<td>
												<ReactSVG src='/icons/094.dostava.svg' beforeInjection={(svg) => {
													svg.setAttribute('width', '28px')
													svg.setAttribute('height', '15px')

													svg.querySelectorAll('.fil0').forEach(path => {
														path.setAttribute('style', 'fill: #eee;')
													})
												}} />
											</td>

											<td>
												<ReactSVG src='/icons/094.dostava.svg' beforeInjection={(svg) => {
													svg.setAttribute('width', '28px')
													svg.setAttribute('height', '15px')

													svg.querySelectorAll('.fil0').forEach(path => {
														path.setAttribute('style', 'fill: #eee;')
													})
												}} />
											</td>

											<td>
												<ReactSVG src='/icons/094.dostava.svg' beforeInjection={(svg) => {
													svg.setAttribute('width', '28px')
													svg.setAttribute('height', '15px')

													svg.querySelectorAll('.fil0').forEach(path => {
														path.setAttribute('style', 'fill: #eee;')
													})
												}} />
											</td>

											<td>
												<ReactSVG src='/icons/094.dostava.svg' beforeInjection={(svg) => {
													svg.setAttribute('width', '28px')
													svg.setAttribute('height', '15px')

													svg.querySelectorAll('.fil0').forEach(path => {
														path.setAttribute('style', 'fill: #eee;')
													})
												}} />
											</td>

											<td>
												<ReactSVG src='/icons/094.dostava.svg' beforeInjection={(svg) => {
													svg.setAttribute('width', '28px')
													svg.setAttribute('height', '15px')

													svg.querySelectorAll('.fil0').forEach(path => {
														path.setAttribute('style', 'fill: #eee;')
													})
												}} />
											</td>
										</tr>
									</>
								)}
							</tbody>
						</table>
					))}
				</div>

				<div className='vehicle-part-delivery-policy'>
					<p>{deliveryInfo.deliveryPolicy}</p>
				</div>
			</div>
		</section>
	)
}

Delivery.propTypes = {
	deliveryInfo: PropTypes.shape({
		cities: PropTypes.arrayOf(PropTypes.shape({
			name: PropTypes.string.isRequired,
			cities: PropTypes.arrayOf(PropTypes.shape({
				name: PropTypes.string.isRequired,
				shortName: PropTypes.string.isRequired,
				freeDeliveryEnabled: PropTypes.bool.isRequired,
				deliveryCost: PropTypes.number.isRequired,
				deliveryCostUrban: PropTypes.number.isRequired,
				deliveryCostRural: PropTypes.number.isRequired,
				deliveryDays: PropTypes.shape({
					min: PropTypes.number.isRequired,
					max: PropTypes.number.isRequired,
				}).isRequired,
				deliveryWeekdays: {
					monday: PropTypes.bool.isRequired,
					tuesday: PropTypes.bool.isRequired,
					wednesday: PropTypes.bool.isRequired,
					thursday: PropTypes.bool.isRequired,
					friday: PropTypes.bool.isRequired,
					saturday: PropTypes.bool.isRequired,
					sunday: PropTypes.bool.isRequired,
				},
				deliveryFrequencyType: PropTypes.string.isRequired,
				deliveryFrequencyDescription: PropTypes.string.isRequired,
				zone: PropTypes.string.isRequired,
				freeDeliveryCondition: PropTypes.string.isRequired,
				freeDeliveryMinAmount: PropTypes.number.isRequired,
				freeDeliveryDescription: PropTypes.string.isRequired,
				deliveryNotes: PropTypes.string.isRequired,
			})).isRequired,
		})).isRequired,
		totalCities: PropTypes.number.isRequired,
		note: PropTypes.string.isRequired,
		deliveryPolicy: PropTypes.string.isRequired,
	}).isRequired,
}

const mapStateToProps = state => ({
	deliveryInfo: getDeliveryInfo(state),
})

export default connect(mapStateToProps)(Delivery)